import { lazy, Suspense } from 'react'
import Loader from '../custom/loader/main';

const Main = lazy(() => import('../components/approval/viewResultDetails/main'));

const ViewResultDetails = () => {
  return (
    <Suspense fallback={<Loader/>}>
      <Main/>
    </Suspense>
  )
}

export default ViewResultDetails;